<div class="filters">
  <!-- Autocompletado por nombre -->
  <mat-form-field class="mat-autocomplete-custom school-dashboard-dropdown">
    <input 
      type="text" 
      matInput 
      [formControl]="searchControl" 
      [matAutocomplete]="auto"
      (focus)="openAutocomplete()"
      autocomplete="off"
      class="autocomplete-input"
      placeholder="Buscar Estudiante"
    />
  
    <mat-autocomplete #auto="matAutocomplete" (closed)="onAutocompleteClosed()">
      <mat-option 
        *ngFor="let option of filteredStudents" 
        [value]="option"
        (click)="setStudent(option)">
        {{ option }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <!-- Dropdown de grado -->
  <app-school-dashboard-dropdown
    [idField]="'id'"
    [textField]="'name'"
    [staticData]="grades"
    placeholder="Seleccionar Grado"
    [singleSelection]="true"
    (selectionChanged)="handleGradeChange($event)">
  </app-school-dashboard-dropdown>
  
    <!-- Dropdown de Semestre -->
    <app-school-dashboard-dropdown
    [apiEndpoint]="'api/socioEmotionalSkillTestResult/school/' + schoolId + '/semesters'"
    [idField]="'name'"
    [textField]="'name'"
    placeholder="Seleccionar semestre"
    [singleSelection]="true"
    (selectionChanged)="handleSemesterChange($event)">
  </app-school-dashboard-dropdown>

</div>